<template>
    <!-- 商户进件 -->
    <div class="merchantList">
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="searchForm.phone" placeholder="请输入代理商账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="searchForm.nickname" placeholder="请输入代理商名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="searchForm.status" clearable placeholder="请选择状态">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="启用" value="10"></el-option>
                        <el-option label="停用" value="20"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="rangeDate" type="datetimerange" range-separator="至"
                        start-placeholder="添加开始日期" end-placeholder="添加结束日期" value-format="yyyy-MM-dd"
                        @change="pickerChange"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
                        @click="onSearch(searchForm)">查询</el-button>
                    <el-button size="medium" type="primary"  style="font-size: 12px;"
                        @click="seeClick()">查询方案详情</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="phaseRateAgentList" size="mini" border style="width: 100%" v-loading="loading">
                <!-- 序号 -->
                <el-table-column header-align="center" align="center" fixed type="index" label="ID"
                    min-width="80"></el-table-column>
                <el-table-column header-align="center" align="center" prop="phone" label="代理商账号" min-width="160"></el-table-column>
                <el-table-column header-align="center" align="center" prop="nickname" label="代理商名称" min-width="160"></el-table-column>
                <el-table-column header-align="center" align="center" prop="brand_name" label="政策名称" min-width="160"></el-table-column>
                <el-table-column header-align="center" align="center" prop="create_time" label="添加时间" min-width="180"></el-table-column>
                <el-table-column header-align="center" align="center" prop="plan_name" label="涨价前结算价" min-width="160">
                    <template slot-scope="scope">
                        <span >{{scope.row.base_rate}}%</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="status_text" label="状态" min-width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 10">启用</span>
                        <span v-else style="color: red;">停用</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="update_time" label="更新时间" min-width="180"></el-table-column>
                
                <el-table-column v-if="status == 10" header-align="center" align="center" fixed="right" label="操作" min-width="200">
                    <template slot-scope="scope">
                        <el-button @click="deactivate(scope.row,20)" type="text" size="small" v-if="scope.row.status == 10">停用</el-button>
                        <el-button @click="deactivate(scope.row,10)" type="text" size="small" v-if="scope.row.status == 20">启用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
                layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </el-card>

        <el-dialog title="查看方案" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false"
            :before-close="handleClose">

            <el-form :model="formInline" label-width="120px" :rules="rules" ref="ruleForm">
                <el-form-item label="方案名称" prop="plan_name" style="width: 90%;">
                    <el-input placeholder="请输入方案名称" style="width: 100%;" v-model="formInline.plan_name" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="涨价规则" prop="plan_rule" style="width: 90%;">
                    <el-form label-position="top" label-width="80px">
                            <el-form-item>
                                <el-table :data="plan_rule" border max-height="456px">
                                    <el-table-column
                                        header-align="center"
                                        align="center"
                                        min-width="160"
                                        prop="is_default"
                                        label="涨价标准"
                                    >
                                        <template slot-scope="scope">
                                            <span>商户自绑机日起</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        align="center"
                                        min-width="300"
                                        prop=""
                                        label="涨价天数区间"
                                    >
                                        <template slot-scope="scope">
                                            <div style="display: flex;align-items: center; justify-content: center;">
                                                <el-input maxlength="5"
                                                     :disabled="true"
                                                    v-model="scope.row.day_from"
                                                    placeholder="开始天数"
                                                ></el-input> 
                                                <span style="text-align: center;width: 60px;font-size: 20px;"> ~ </span>
                                                <el-input maxlength="5"
                                                     :disabled="true"
                                                    v-model="scope.row.day_end"
                                                    placeholder="结束天数"
                                                ></el-input>
                                            </div>
                                            
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        align="center"
                                        min-width="280"
                                        prop="up_type"
                                        label="涨价类型"
                                    >
                                        <template slot-scope="scope">
                                            <span style="margin-right: 10px;">代理商结算价:</span>
                                            <el-select :disabled="true" style="width: 140px;" size v-model="scope.row.up_type" clearable placeholder="请选择涨价类型">
                                                <el-option label="上涨" :value="1"></el-option>
                                                <el-option label="涨至" :value="2"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        align="center"
                                        min-width="200"
                                        prop="up_value"
                                        label="涨价幅度"
                                    >
                                        <template slot-scope="scope">
                                            <el-input  maxlength="5"
                                            style="width: 140px;"
                                                 :disabled="true"
                                                v-model="scope.row.up_value"
                                                placeholder="请输入涨价幅度"
                                            ></el-input>
                                            <span style="margin-left: 10px;">%</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                    </el-form>
                    
                </el-form-item>
                <el-form-item label="备注(选填)" prop="remark" style="width: 90%;">
                    <el-input type="textarea" placeholder="请输入备注" style="width: 100%;" v-model="formInline.remark" :disabled="true" maxlength="100"></el-input>
                </el-form-item>
             </el-form>    
        </el-dialog>
        
    </div>
</template>

<script>
    export default {
        name: "phaseRateDetail",
        data() {
            return {
                searchForm: {
                    plan_id:this.$route.query.id,
                    phone:'',
                    status: '',
                    nickname:'',
                    start_time: '',
                    end_time: '',
                    page:1,
                    limit:10
                },
                status:this.$route.query.status,
                rangeDate: '',
                id: '',
                phaseRateAgentList: [],
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0, //总数
                loading: true,
                agentList:[],
                brandList: [],
                //添加方案
                dialogVisible: false,
                formInline: {
                    remark: '',
                    plan_name: '',
                    plan_rule: []
                } ,
                plan_rule:[{
                      day_from:'',
                      day_end:'',
                      up_type:1,
                      up_value:''
                }]
            }
        },
        created() {

        },
        mounted() {
            this.$api.post('settle_rate/userList', {}, res => { //获取代理商
                if (res.code == 0) {
                    this.agentList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
            this.getData({
                page: 1,
                limit: 10
            })
        },
        methods: {
            agentSelClick(e){
                console.log(e);
                for (let item of this.agentList) {
                    if (item.id == e) {
                        this.formInlineAgent.user_name = item.nickname
                        this.getBrandList(item.id)
                    }
                }
            },
            getBrandList(id){
                this.$api.post('settle_rate/userBrand', {'user_id':id}, res => { //获取代理商
                console.log(res);
                    if (res.code == 0) {
                        this.brandList = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
                
            },
            onSearch(searchFrom) {
                this.currentPage = 1;
                searchFrom.page = 1;
                this.getData(searchFrom);
            },
            getData(params) { //获取数据
                this.loading = true;
                params.plan_id = this.$route.query.id
                this.$api.post("settle_rate/selSettleRateUpPlanUserList", params, res => {
                    let data = res.data;
                    this.total = data.count; //总数
                    this.phaseRateAgentList = res.data.list;
                    //渲染结束后取消加载
                    this.loading = false;
                })
            },
            handleCurrentChange(page) { //当前选中页
                this.currentPage = page;
                this.searchForm.page = page;
                this.searchForm.limit = this.pageSize;
                this.getData(this.searchForm);
            },
            handleSizeChange(limit) { //条数
                this.currentPage = 1;
                this.pageSize = limit;
                this.searchForm.page = 1;
                this.searchForm.limit = limit;
                this.getData(this.searchForm);
            },
            pickerChange(DateArr) { //时间选择器
                this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
            },

            //关闭弹框
            handleClose() {
                this.dialogVisible = false;
                this.$refs['ruleForm'].resetFields();
            },

            seeClick(){
                this.changeFree ='查看方案'
                this.$api.post("settle_rate/planInfo", {plan_id:this.$route.query.id}, res => {
                    if (res.code == 0) {
                        this.formInline = res.data;
                        this.plan_rule = this.formInline.rule
                        this.dialogVisible = true;
                    }
                })
            },
            //停用
            deactivate(row,status) {
                this.$api.post("settle_rate/upSettleRateUpPlanUserStatus", {id:row.id,status:status}, res => {
                        if (res.code == 0) {
                            this.$message.success(res.msg);
                            this.getData({
                                page: 1,
                                limit: 10
                            })
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    .el-form-item {
        margin-bottom: 20px;
    }

    .el-select,
    .el-input {
        width: 180px;
        font-size: 12px;
    }
</style>